import styled from "styled-components";

export const CheckboxLayout = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 15px;
`;
